<template>
  <div class="payment-icons">
    <ul class="payment-icons__list">
      <li>
        <div class="payment-icons__link">
          <IconPaymentMethodsIdeal
            class="icon icon--ideal"
            filled
          />
          <span class="visually-hidden">iDeal</span>
        </div>
      </li>
      <li>
        <div class="payment-icons__link">
          <IconPaymentMethodsMastercard
            class="icon icon--mastercard"
            filled
          />
          <span class="visually-hidden">Mastercard</span>
        </div>
      </li>
      <li>
        <div class="payment-icons__link">
          <IconPaymentMethodsVisa
            class="icon icon--visa"
            filled
          />
          <span class="visually-hidden">Visa</span>
        </div>
      </li>
      <li>
        <div class="payment-icons__link">
          <IconPaymentMethodsMaestro
            class="icon icon--maestro"
            filled
          />
          <span class="visually-hidden">Maestro</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<style src="~layers/app/components/App/PaymentIcons.css" />
